// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3zdxI","inputDescription":"styles_inputDescription__2ALNy"};